export const messages = {
  email: "Email ID is required",
  validEmail: "Enter a valid email",
  firtName: "First name is required",
  validirstName: "First name must only contain letters, spaces, apostrophes, and hyphens",
  lastName: "Last name is required",
  validLastName: "Last name must only contain letters, spaces, apostrophes, and hyphens",
  minLenFirstName: "First name must be at least 2 characters",
  maxLenFirstName: "First name must be at most 50 characters",
  minLenLastName: "Last name must be at least 1 character",
  maxLenLastName: "Last name must be at most 50 characters",
};

export const patterns = {
  email:
    /^(?!.*\.\.)(?!.*--)(?!^\s)(?!^\-)(?!^\.)[a-zA-Z0-9!#$%&'*+/=?^_{|}~().,:;<>[\]\\" -]+(?<!-)(?<!\.)@([a-zA-Z0-9 ]+(?:-[a-zA-Z0-9 ]+)*)(\s*\.\s*[a-zA-Z]{2,})$/,
  firstName: /^[a-zA-Z\s'-]+$/,
  lastName: /^[a-zA-Z\s'-]+$/,
};

export const MEET_S3_PATH = '';

export const SCHOOL_ADMIN = 'schooladmin';
export const TEACHER_ROLE = 'teacher';
export const STUDENT_ROLE = 'student';
export const PTA_ROLE = 'pta';